import $axios from '../api.js'

const state = () => ({
    startTime : localStorage.getItem('activity_numerical') ? new Date(new Date(JSON.parse(localStorage.getItem('activity_numerical')).startTimeActual).getTime() - ( 1000 * ( parseInt(JSON.parse(localStorage.getItem('activity_numerical')).timeRunning.seconds)) *
        (parseInt( JSON.parse(localStorage.getItem('activity_numerical')).timeRunning.minute))))  : [],
    endTime  : localStorage.getItem('activity_numerical') ? new Date(JSON.parse(localStorage.getItem('activity_numerical')).endTime) : [],
    startTimeActual : localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).startTimeActual : [],
    timeRunning : localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).timeRunning : {
        minute: 0,
        seconds: 0,
    },
    type_question : localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).type_question : [],
    questions: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).questions : [],
    answers: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).answers : [],
    instruction: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).instruction : [],
    questionIndex: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).questionIndex : 0,
    bar_active: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).bar_active : Array(),
    bar_visited: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).bar_visited : Array(),
    answerCheck: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).answerCheck : Array(),
    questionResponses: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).questionResponses : Array(),
    step: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).step : 1,
    is_finish: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).is_finish : 0,
    intro: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).intro : true,
    show_question: localStorage.getItem('activity_numerical') ? JSON.parse(localStorage.getItem('activity_numerical')).show_question : 5,
})

const mutations = {
    //MEMASUKKAN DATA KE STATE OUTLETS
    ASSIGN_DATA(state, payload) {
        state.questions = payload.data
        state.type_question = payload.type_q
        state.instruction = payload.instruction[0]
    },
    //MEMASUKKAN DATA KE STATE OUTLETS
    ASSIGN_DATA_ACTIVITY(state, payload) {
        state.questionIndex = payload.questionIndex;
        state.bar_active= payload.bar_active;
        state.bar_visited= payload.bar_visited;
        state.answerCheck= payload.answerCheck;
        state.questionResponses= payload.questionResponses;
        state.step= payload.step;
        state.intro= payload.intro;
        state.startTime= payload.startTime;
        state.endTime= payload.endTime;
        state.endTimeActual= payload.endTimeActual;
        state.startTimeActual= payload.startTimeActual;
        state.questions = payload.questions;
        state.show_question = payload.show_question;
        localStorage.setItem('activity_numerical', JSON.stringify(state))
    },
    ASSIGN_DATA_TIME_TRACKING(state, payload) {
        state.timeRunning.minute = (29 - payload.minutes);
        state.timeRunning.seconds = (60 - payload.seconds);

        localStorage.setItem('activity_numerical', JSON.stringify(state))
    },
    ASSIGN_ANSWER_USER(state,payload){
        if (payload.answer.length > 1) {
            state.intro = false;
            state.type_question = payload.type_q;
            state.questionResponses = payload.answer;
            state.questionIndex = payload.answer.length;
            state.step = Number( (payload.answer.length / state.show_question) + 2).toFixed(0);
            localStorage.setItem('activity_numerical', JSON.stringify(state));

        }

    }
}

const actions = {
    //FUNGSI INI UNTUK MELAKUKAN REQUEST DATA QUESTIONS DARI SERVER
    getQuestions({ commit, state }, payload) {
        return new Promise((resolve, reject) => {
            //REQUEST DATA DENGAN ENDPOINT /OUTLETS
            var type_q = '';
            if (localStorage.getItem('activity_numerical')) {
                type_q = JSON.parse(localStorage.getItem('activity_numerical')).type_question;
            }
            $axios.get(`/questions?lang=${payload.lang}&type=${payload.type}&question_type=${type_q}`)
                .then((response) => {
                    //SIMPAN DATA KE STATE MELALUI MUTATIONS
                    let data = {
                        type_q : response.data.type_q,
                        data : response.data.data,
                        instruction: response.data.instruction
                    };
                    commit('ASSIGN_DATA', data)
                    resolve(response.data)
                })
        })
    },
    setTimeTracking({ commit, state }, payload) {

        commit('ASSIGN_DATA_TIME_TRACKING', payload)
    },
    async submitAnswer({ commit, state, dispatch }, payload){
        await dispatch('submitAnswer', {
            lang: localStorage.lang,
            type: 'F',
            type_question: state.type_question,
            client_id : localStorage.client_id,
            answer: state.questionResponses
        },{root: true})
        commit('SET_SECTION', 7, { root: true });
    },
    async next({ commit, state, dispatch }, payload){

        state.bar_visited[state.step] = true;
        var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        var last_index = 1;
        for (let i=state.questionIndex;i<state.questionIndex+state.show_question;i++){

            if (state.questionResponses[i] == null && i < state.questions.length ){

                let pesan = localStorage.lang == 'id' ? 'Silahkan menjawab pertanyaan untuk maju' : 'Please answer the question to continue'

                alert(pesan)
                state.required = true;
                break;
            }else{
                if (i >= state.questions.length-1){
                    state.is_finish = 1;
                    commit('ASSIGN_DATA_ACTIVITY', state)
                    await dispatch('submitAnswer', {
                        lang: localStorage.lang,
                        type: 'F',
                        type_question: state.type_question,
                        client_id : localStorage.client_id,
                        is_finish: state.is_finish,
                        answer: state.questionResponses
                    },{root: true})
                    commit('SET_SECTION', 7, { root: true });
                    break;
                }
                last_index = i;
                state.required = false;
            }
        }

        if (state.required == false){
            state.step++;
            state.required = false;

            state.questionIndex = last_index+1;
            state.bar_active[state.step] = true;
            state.bar_visited[state.step] = false;
        }

        state.loading = false;
        commit('ASSIGN_DATA_ACTIVITY', state);
        await dispatch('submitAnswer', {
            lang: localStorage.lang,
            type: 'F',
            type_question: state.type_question,
            client_id : localStorage.client_id,
            is_finish: state.is_finish,
            answer: state.questionResponses
        },{root: true});


    },
    nextIntro({ commit, state }, payload){

        state.bar_visited[state.step] = true;
        state.answerCheck[state.questionIndex] = true;
            if (state.questionStep == false) {
                state.ProductiveCheck[state.questionIndex] = true;
            }
        state.questionIndex++;
        state.step++;

            if (state.questionIndex === state.questions.length) {
                state.questionStep = false;
            }
        const now = new Date();

        state.startTime = new Date(now.getTime());
        state.startTimeActual = new Date(now.getTime());
        state.endTime = new Date(now.getTime() + (1000 * 60 * (30)));
        state.endTimeActual = state.endTime;
        state.bar_active[state.step] = true;
        state.bar_visited[state.step] = false;
        state.intro = false;
        commit('ASSIGN_DATA_ACTIVITY', state)
    },
    logout({ commit }, payload) {
        localStorage.clear(); //RESET LOCAL STORAGE MENJADI NULL
        commit('SET_TOKEN', null, { root: true }) //RESET STATE TOKEN MENJADI NULL
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
